import React from 'react'
import { compose } from 'recompose'
import { withI18next } from '../lib/withI18next'

function createMarkup(markup) {
  return { __html: markup }
}

function refreshPage() {
  window.location.reload()
}

class Error extends React.Component {
  static getInitialProps({ res, req, err }) {
    const statusCode = res ? res.statusCode : err ? err.statusCode : null
    const path = req.path
    return { statusCode, path }
  }

  render() {
    const { statusCode, path, t } = this.props
    const title = statusCode === 404
      ? 'error-page_not-found-title'
      :  'error-page_internal-error-title'
    const desc = statusCode === 404
    ? 'error-page_not-found-description' :
      'error-page_internal-error-description'
    return (
      <div className="error-page">
        <div className="inner">
          <style dangerouslySetInnerHTML={{ __html: 'body { margin: 0 }' }} />
          {
            statusCode ?
              <h1 className="code">{statusCode}</h1> : null
          }
          <h2 className="title">{t(title)}</h2>
          {
            desc &&
            <div
              className="desc"
              dangerouslySetInnerHTML={createMarkup(t(desc, { email: 'mazdaserviceinfo@tweddle.com' }))}
            />
          }
          <div className="desc m-t-md">
            <a href="/" className="button m-l-sm m-r-sm">{t('error-page_return-home')}</a>
            {
              statusCode !== 404 && <a href={path} onClick={refreshPage} className="button m-l-sm m-r-sm">{t('error-page_reload-page')}</a>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  withI18next('common')
)(Error)



// WEBPACK FOOTER //
// ./pages/_error.js